module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<fieldset class="youtube-settings-container">\n    <legend data-target="#youtube-settings-properties">YouTube Settings</legend>\n        <div class="checkbox-grid">\n            <label>\n                <input type="checkbox" id="controls">\n                <span class="custom-checkbox"></span>\n                Enable controls\n            </label>\n            <label>\n                <input type="checkbox" id="autoplay">\n                <span class="custom-checkbox"></span>\n                Autoplay\n                <i class="glyphicon glyphicon-exclamation-sign autoplay" data-content="Autoplay is not supported on tablets and mobile devices"></i>\n            </label>\n            <label>\n                <input type="checkbox" id="loop">\n                <span class="custom-checkbox"></span>\n                Loop\n            </label>\n            <label>\n                <input type="checkbox" id="mute">\n                <span class="custom-checkbox"></span>\n                Mute\n            </label>\n        </div>\n</fieldset>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/assets/youtube/settings/YouTubeSettingsPropertiesView.tpl
// module id = 2083
// module chunks = 0